import * as FileSaver from 'file-saver';
import { BsDownload } from 'react-icons/bs';
import XLSX from 'sheetjs-style';
import { useDispatch } from 'react-redux';
import { formatDate } from '../../actions/global-actions';
import Swal from 'sweetalert2';
import { getCases } from '../../actions/case-actions';
import { CASE_INSTANCES, CASE_STATUSES } from '../../routes/legal-cases/case-data';
import { useState } from 'react';

const ExcelGenerator = ({ token, form, selectedReport }) => {

    const dispatch = useDispatch();
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const extension = '.xlsx';
    const [isGenerating, setIsGenerating] = useState(false);

    const getFunction = (response) => {
        let data = response.data;
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log('response', data.data);
            let dataToFile = [];
            if (data.data && data.data.length > 0) {
                data.data.forEach( caseObj => {
                    let type = caseObj.caseType;
                    let newCase = {
                        // Datos del generales del caso
                        "Empresa": caseObj.legalCompany || 'AYH',
                        "Fecha": formatDate(caseObj.date, 1),
                        "Tipo": type.charAt(0).toUpperCase() + type.slice(1),
                        "Radicado": caseObj.filingNumber,
                        "Departamento": caseObj.province,
                        "Ciudad": caseObj.city,
                        "Órgano de inv": caseObj.researchOrgan.organId.description,
                        "Abogado": `${caseObj.attorneyInCharge.userId.firstName} ${caseObj.attorneyInCharge.userId.lastName}`,
                        "Personero - Funcionario": caseObj.representative || '',
                        // Cliente
                        "Cliente": `${caseObj.client.clientId.firstName} ${caseObj.client.clientId.lastName}`,
                        "Detalles": `${caseObj.case.position}`,
                        "Entidad Territorial": caseObj.case.territorialEntity,
                        "Departamento de ejecución": caseObj.case.executionProvince,
                        "Ciudad de ejecución": caseObj.case.executionCity,
                        // Datos particulares
                        "Resumen": caseObj.summary,
                        "Observaciones": caseObj.observation,
                        "Acontecimientos": caseObj.events,
                        "Instancia": CASE_INSTANCES[caseObj.instance],
                        "Auto de apertura": caseObj.autoOpening,
                        "Fecha del auto de apertura": formatDate(caseObj.autoOpeningDate, 1),
                        "Fecha de notificación": formatDate(caseObj.notificationDate, 1),
                        "Aseguradora": "",
                        "Estado de documentos": CASE_STATUSES[caseObj.status],
                        "Estado del caso": caseObj.caseStatus || "Abierto",
                    }
                    if (selectedReport === '2') {
                        newCase["Comentarios"] = '';
                        caseObj.comments.forEach(comment => {
                            let type = comment.type?comment.type:'Comentario';
                            newCase["Comentarios"] += `${formatDate(comment.date,2)} (${type}): ${comment.comment} \n`;
                        });
                    }
                    if (caseObj.status !== 'not checked') {
                        newCase["Aseguradora"] = caseObj.company.companyId.description;
                    }
                    //console.log('newCase', newCase);
                    dataToFile.push(newCase);
                });
            }
            const fileName = selectedReport === '1'?`Casos jurídicos ${formatDate(new Date(), 2)}`:`Comentarios ${formatDate(new Date(),2)}`;
            const ws = XLSX.utils.json_to_sheet(dataToFile);
            const wb = { Sheets: { 'Datos': ws}, SheetNames: ['Datos'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const generated = new Blob([excelBuffer],  {type: fileType });
            FileSaver.saveAs(generated, `${fileName}${extension}`);
            setIsGenerating(false);
        }
    }
    const exportToExcel =  async() => {
        if (isGenerating) {
            Swal.fire({
                title:"Advertencia",
                confirmButtonColor:"#76b4ff",
                text: "El archivo se está generando, por favor, espere.."
            });
            return
        } 
        let params = form;
        if (selectedReport === '2') {
            params = {
                ...params,
                query: { "comments.0" : { "$exists" : true } }
            }
        }
        dispatch( getCases( params, 0, getFunction, token, 500 ) );
        setIsGenerating(true);
    }

    return (
        <button className="d-flex search-button with-text justify-content-center align-items-center" onClick={(e)=>exportToExcel()}>
            <span>Descargar Excel</span>
            <BsDownload/>
        </button>
    )
}

export default ExcelGenerator;